import { Router } from '@angular/router';
import { GridAction } from '@eforall/dashboard';
import { LIST_ITEM } from '../dashboard-list.part.service';


export function getGridActions(router: Router) {

	const actions: GridAction<LIST_ITEM>[] = [
		{
			iconClass: 'fa-car',
			label: 'Open Dashboard',
			separated: false,
			isEnabled: (rows: LIST_ITEM[]) => {
				if (rows.length !== 1) return false;
				return true;
			},
			execute: async (rows: LIST_ITEM[]) => {
				if (!rows[0]) return;
				router.navigate([rows[0].urlPath]);
			},
		}
	];
	return actions;
}
